export const main = {
	title: 'We are a Quality Driven Software & Product Development Team',
	subtitle: ' Aspire. Create. Understand.',
	subtitle1: ' Aspire.',
	subtitle2: ' Create.',
	subtitle3: ' Understand.',
	button1: 'Get Started',
	button2: 'Contact Us',
}
